<template>
  <div class="bg-[#F0F0F0] p-3 -mx-4 md:-mx-1">
    <div class="font-semibold text-lg text-[#171717] mb-3">{{ $t('catalog.categories') }}</div>
    <div class="grid md:grid-cols-3 gap-2">
      <div class="flex items-center w-full border bg-[#FFF] hover:bg-[#F8F8F8] hover:border-gray-900 px-3 py-2 rounded cursor-pointer" v-for="category in categories">
        <div id="globalcatalog-category-item-click" class="flex justify-between items-center font-semibold text-base text-[#171717] w-full" @click="setSelectedCategory(category)">
          <span>{{ category.CategoryName }}</span>
          <i class="ri-arrow-right-s-line text-[#464646] text-xl"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useGlobalCatalogStore } from "@/stores/globalCatalogStore"

const globalCatalogStore = useGlobalCatalogStore()
const categories = computed(() => globalCatalogStore.categories);

const setSelectedCategory = category => {
  globalCatalogStore.setIsSelectedForCategories(category, true)
}
</script>
